// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const PymeWrapper: StatelessFunctionalComponent<*> = styled.div`
  padding: 20px 10px !important;
  
  .Pyme {
    &-formRow {
      margin-top: 16px;
      display: flex;
      justify-content: center;

      &-1 {
        max-width: 450px;
        text-align: center;
        margin: auto !important;
      }
    }

    @media (max-width: 700px){
      &-formRow {
        flex-direction: column;
      }
    }

    &-formRow > * {
      margin: 0 10px;
    }

    &-Form {
      display: flex;
      margin-top: 40px;
      margin-bottom: 40px;

      & > div {
        width: 50%;
        display: flex;
        justify-content: center;
      }
      
      & > div:last-child {
        justify-content: flex-start;
      }
      
      &-icon {
        margin-top: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      &-icon img {
        height: auto;
      }
      
      &-wrapper {
        max-width: 350px;
      }

      @media screen and (max-width: 650px) {
        & > div:first-child {
          display: none;
        }

        & > div:last-child {
          width: 100%;
        }

        &-wrapper {
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  /*******************COVERAGE_PLANS*******************/
  .coverage-plans {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 2em;
    /* font-size: 20px; */
    font-size: 16px;
    margin: 2em 1em;
  }

  .coverage-plan {
    color:  #949494;
    cursor: pointer;
    text-align: center;

    &-title {
      position: relative;
      text-transform: capitalize;
      vertical-align: middle;
      line-height: 3.5em;
      color: #FFF;
      height: 3.5em;
      margin-right: 1em;
      object-fit: contain;
      border-radius: 0 0 0 0.9em;
      background-image: linear-gradient(90deg,#c5c5c5, #5f5f5f 100%);
      box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);

      &:after {
        content:"";
        position: absolute;
        top:0;
        left:100%;
        height:0;
        width:0;
        border-width:1.75em 0 1.75em 1em;
        border-style:solid;
        border-color:transparent;
        border-left-color:#5f5f5f;
      }
    }

    &-amount {
      margin: 0.5em 1em 0.2em 0;
      margin-right: 1em;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      font-size: 1.3em;
      letter-spacing: normal;
    }

    &-desc {
      margin: 0 1.5em 0 .5em;
      font-size: 0.75em;
    }
  }

  @media (max-width: 600px) {
    .coverage-plans {
      display: grid;
      grid-template-columns: 1fr;
      margin: 0 1em;
    }
    .coverage-plan {
      margin: 1em 0.5em;
    }
  }
  
  .coverage-plan.coverage-plan-selected {
    color: #0033a0;
    -webkit-transition: color 1s;
    transition: color 1s;
    
    .coverage-plan-title:after {
      border-left-color:#003cb6;
    }
    
    .coverage-plan-title {
      background-image: linear-gradient(90deg, #006ada, #003cb6 100%);
    }
  }
  /****************************************************/
  
  /******************COVERAGE_MODULES******************/

  .coverage-modules {
    display: grid;
    grid-template-columns: 1fr;
    padding: 20px 0px;

    &-headers {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      height: 4.5em;
      align-content: end;
    }

    &-container>.coverage-modules {
      display: block;
      font-size: 15px;

      &-slider {
        display: none;
      }
    }

    &-container>.coverage-modules-slider {
      .coverage-module {
        margin: 0 .5em;
        display: grid;
        grid-template-columns: 1fr;

        .coverage-module-title {
          font-size: 1.5em;
          margin-top: 1.5em;
          margin-bottom: 0.5em;
          border-radius: 3px;
          background-image: linear-gradient(169deg, #43b8d3, #26869d);
          transition: margin-top .3s;
        }

        .coverage-module-title.coverage-module-selected {
          margin-top: 0;
          background-image: linear-gradient(117deg, #0033a0, #00194f);
          height: 3.5em;
          line-height: 3.5em;
          transition: margin-top .3s;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .coverage-modules-container>.coverage-modules {
      display: none;

      &-slider {
        display: block;
      }
    }
  }

  .coverage-module {
    display: grid;
    font-size: 15px;
    grid-template-columns: 1fr 3fr;
    padding-top: 1em;

    &-title {
      border-radius: 3px;
      background: #666666;
      color: #FFF;
      height: 3.5em;
      line-height: 3.5em;
      cursor: pointer;
      text-align: center;
      align-self: end;
      transition: height .5s;

      &:nth-child(1) {
        background: #909090;
      }
      &:nth-child(2) {
        background: #7f7f7f;
      }
      &:nth-child(3) {
        background: #666666;
      }
      &:nth-child(4) {
        background: #555555;
      }
    }

    &-title.coverage-module-selected {
      background-image: linear-gradient(117deg, #0033a0, #00194f);
      height: 4.5em;
      line-height: 4.5em;
      font-weight: bold;
      transition: height .3s ease;
    }

    &-animate {
      animation: module-shadow 3s 1 ease;
    }

    &-img {
      position: relative;
      padding-top: 45px;

      img {
        display: block;
        margin: 0 auto;
        width: 85%;
      }
    }

    &-coverages {
      display: grid;
      grid-template: auto / 1fr;

      .coverage-module-row {
        font-size: 0.75em;
        display: grid;
        grid-template-columns: 4fr 2fr;
        grid-column-gap: 2px;
        line-height: 1.2em;
        padding: 6px 0px;

        &:nth-child(even) {
          background: #e0e0e0;
        }

        & > div:first-child {
          display: inline-block;
          list-style-position: inside;
          margin-left: 1em;
        }

        & > div:last-child {
          margin: 0px 1em;
          display: flex;
          text-align: right;
          align-items: center;
          justify-content: flex-end;
        }
      }
    }
  }

  @keyframes module-shadow {
      0%   { box-shadow: none }
      20%  { box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.11), 0 0 25px 0 rgba(0, 0, 0, 0.09);
             background-color: #e0e0e0; }
      100% { box-shadow: none }
  }
  /****************************************************/
`;

export default PymeWrapper;
